import { SagaIterator } from 'redux-saga';
import { call, takeLatest } from 'redux-saga/effects';
import {
  DataForDashboard,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  SOFORTSCHUTZ_AVAILABLE_REQUEST,
  ZAEHLSTUECKEREQUEST,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = ({ appId, angebotsId, beginn }: DataForDashboard) => {
  return [
    new GlobalActions().resetBeginnAblauf(appId, angebotsId),
    new GlobalActions().updateBeginnAblauf({ appId, angebotsId, beginn }),
    new GlobalActions().updateSofortschutzAvailable(),
    new GlobalActions().updateZaehlstuecke(),
  ];
};

export const updateAppSuccessActions = () => [
  GlobalActions.ZAEHLSTUECKE_RECEIVED,
  GlobalActions.SOFORTSCHUTZ_AVAILABLE,
];

export const updateAppFailActions = () => [
  SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_FAILED,
  ZAEHLSTUECKEREQUEST.ZAEHLSTUECKE_REQUEST_FAILED,
];

export function* afterShopSuccess() {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }));
}

const updateAppAndTarifiereAll = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
    afterShopSuccess,
  ),
);

/**
 * An offer of the Tiergruppe that is not the last one of its group only gets its beginn and
 * ablauf updated: the requests that look at the whole Warenkorb (sofortschutz, zaehlstuecke, the
 * Shop-Tarifierung) run once, with the take-over of the last offer. Nothing is tarifiert here,
 * so there is no tarifierung to announce and no navigation.
 */
export function* updateBeginnAblaufOnly({ payload }: GlobalAction<DataForDashboard>): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const { appId, angebotsId, beginn } = payload;
  yield call(globalPut.put, new GlobalActions().resetBeginnAblauf(appId, angebotsId));
  yield call(globalPut.put, new GlobalActions().updateBeginnAblauf({ appId, angebotsId, beginn }));
}

export function* updateAppAndTarifiere(action: GlobalAction<DataForDashboard>): SagaIterator {
  if (action.payload?.deferTarifierung) {
    return yield call(updateBeginnAblaufOnly, action);
  }
  return yield call(updateAppAndTarifiereAll, action);
}

export function* watchInDashboardUebernehmen() {
  yield takeLatest(GlobalActions.IN_DASHBOARD_UEBERNEHMEN, updateAppAndTarifiere);
}
